export default __webpack_public_path__ + "locales/uk-UA/People.json?hash=7fd81b4fa82b6257e848f2f8c0084186";